export function appendRecord(history: HistoryLog, record: RecordEntry): HistoryLog {
  return [...history.slice(), {...record}];
}
